import React from 'react';
import PropTypes from 'prop-types';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logbook from './Logbook';

const styles = () => ({
  panel: {
    margin: 0,
  },
  panelDetails: {
    padding: '0px',
  },
  panelSummary: {
    display: 'flex',
    justifyContent: 'center !important',
    minHeight: '16px !important',
    height: '50px',
  },
  panelHeader: {
    textAlign: 'right',
    flexGrow: '1',
  },
});

function ExpandableLogbook(props) {
  const {
    expanded,
    toggleLogbookExpanded,
    elephantId,
    focusedDate,
    onDateFocused,
    classes: {
      panel, panelDetails, panelSummary, panelHeader,
    },
  } = props;

  return (
    <Paper>
      <ExpansionPanel expanded={expanded} className={panel}>
        <ExpansionPanelSummary
          className={panelSummary}
          onClick={() => toggleLogbookExpanded(!expanded)}
          expandIcon={<FontAwesomeIcon icon="angle-up" />}
        >
          <div className={panelHeader}>
            {expanded ? 'Hide logbook' : 'Show logbook'}
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={panelDetails}>
          {elephantId
            && (
            <Logbook
              active={expanded}
              focusedDate={focusedDate}
              onDateFocused={onDateFocused}
              elephantId={elephantId}
            />
            )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Paper>
  );
}

ExpandableLogbook.propTypes = {
  classes: PropTypes.shape({
    panelDetails: PropTypes.string.isRequired,
  }).isRequired,
  elephantId: PropTypes.number.isRequired,
  toggleLogbookExpanded: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  focusedDate: PropTypes.shape(),
  onDateFocused: PropTypes.func,
};

ExpandableLogbook.defaultProps = {
  focusedDate: null,
  onDateFocused: () => {},
};


export default withStyles(styles)(ExpandableLogbook);



// WEBPACK FOOTER //
// ./src/layout/logbook/ExpandableLogbook.jsx